import { ref, onMounted, onUnmounted, type Ref } from 'vue';

const MD_BREAK_POINT = 768;

export function useMobile(): { isMobile: Ref<boolean> } {
  const isMobile = ref(window.innerWidth < MD_BREAK_POINT);

  function checkMobile(): void {
    isMobile.value = window.innerWidth < MD_BREAK_POINT;
  }

  onMounted(() => {
    window.addEventListener('resize', checkMobile);
    checkMobile();
  });

  onUnmounted(() => {
    window.removeEventListener('resize', checkMobile);
  });

  return { isMobile };
}
